"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = once;
function once(func) {
  var result;
  return function () {
    if (result) {
      return result.returnValue;
    }
    var returnValue = func.apply(void 0, arguments);
    result = {
      returnValue: returnValue
    };
  };
}